import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { AlertTriangle } from "lucide-react";

interface CancelSubscriptionDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  isTrial: boolean;
  endDate: string;
  isProcessing: boolean;
}

const CancelSubscriptionDialog = ({
  open,
  onOpenChange,
  onConfirm,
  isTrial,
  endDate,
  isProcessing
}: CancelSubscriptionDialogProps) => {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <div className="flex items-center gap-2 text-red-600">
            <AlertTriangle className="w-5 h-5" />
            <AlertDialogTitle>
              {isTrial ? 'Cancel Trial?' : 'Cancel Subscription?'}
            </AlertDialogTitle>
          </div>
          <AlertDialogDescription className="space-y-3 pt-2">
            <p>
              {isTrial
                ? "Are you sure you want to cancel your free trial? You won't be charged, but you'll lose access to premium features."
                : "Are you sure you want to cancel your subscription? Your access will continue until the end of your current billing period."}
            </p>
            {endDate && (
              <p className="font-medium text-foreground">
                {isTrial ? 'Trial access' : 'Your subscription'} will remain active until: {endDate}
              </p>
            )}
            <p className="text-xs">
              You can reactivate your subscription anytime without losing your data.
            </p>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isProcessing}>
            Keep {isTrial ? 'Trial' : 'Subscription'}
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            disabled={isProcessing}
            className="bg-red-600 hover:bg-red-700"
          >
            {isProcessing ? 'Cancelling...' : 'Yes, Cancel'}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default CancelSubscriptionDialog;
